import React from "react";
import { Card } from "antd";
import { BaseComponent } from "../../../base/BaseComponent";
import ImageAndCaption from "../../../header/blockchain/ImageAndCaption";
import "./BigCard.less";

export default class BigCard extends BaseComponent {
  render() {
    return (
      <div className="gx-mb-5">
        <div className="big-card">
          {this.antd.colmd12(
            <div className="col-left">{this.props.children}</div>
          )}
          {this.antd.colmd12(
            <div className="col-right">
              <ImageAndCaption src={this.p.image} />
            </div>
          )}
        </div>
      </div>
    );
  }
}
